import React, { Component } from 'react';
import './Video.css';

class Video extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      tx: 0,
      ty: 0,
      videoWidth: 1,
      videoHeight: 1,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
  }

  onLoadedMetadata = () => {
    this.updateLayout();
  }

  onWindowResize = () => {
    this.updateLayout();
  }

  updateLayout() {
    const ww = window.innerWidth;
    const wh = window.innerHeight;
    const vw = this.refs.video.videoWidth;
    const vh = this.refs.video.videoHeight;

    const vr = vw / vh;
    const wr = ww / wh;

    var w, h;
    if (wr < vr) {
      w = vw / vh * wh;
      h = wh;
    } else {
      w = ww;
      h = vh / vw * ww;
    }

    this.setState({
      tx: (ww - w) / 2,
      ty: (wh - h) / 2,
      videoWidth: w,
      videoHeight: h,
    })
  }

  render() {
    return (
      <div ref="container" id="video">
        <video
          ref="video"
          autoPlay
          loop
          playsInline
          src={this.props.videoSrc}
          onLoadedMetadata={this.onLoadedMetadata}
          width={this.state.videoWidth}
          height={this.state.videoHeight}
          style={{
            transform: `translate(${this.state.tx}px, ${this.state.ty}px)`,
          }}
        ></video>
      </div>
      );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/Welcome/Video.js